import { Node } from 'prosemirror-model';
import { EditorView } from 'prosemirror-view';

import { PopperProps } from '../../types';

export type BlockMenuProps = {
  open: boolean;
  anchorEl: PopperProps['anchorEl'];
  view: EditorView;
  menuType?: MenuType;
  isLocalizedContent: boolean;
};

export type BlockMenuListProps = {
  open: boolean;
  anchorEl: PopperProps['anchorEl'];
  view: EditorView;
};

export enum MenuType {
  GENERAL = 'general',
  TURN_INTO = 'turn_into',
}

export type ReplaceInputProps = {
  view: EditorView;
  selectedNode: Node;
  triggerClick: string;
  pos: number;
};

export type enableFunction = (
  open: boolean,
  anchorEl: PopperProps['anchorEl'],
  view: EditorView,
  selectedNode?: any,
) => boolean;

export type clickFunction = (
  open: boolean,
  anchorEl: PopperProps['anchorEl'],
  view: EditorView,
) => void;

export type titleFunction = (
  open: boolean,
  anchorEl: PopperProps['anchorEl'],
  view: EditorView,
) => string;

export enum PlacementType {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}
